import * as React from 'react'
import { cn } from '@/lib/utils'
import { Check } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

interface SelectableBoxProps {
  id: string
  selected: boolean
  onSelect: (id: string) => void
  disabled?: boolean
  children: React.ReactNode
  className?: string
}

export function SelectableBox({
  id,
  selected,
  onSelect,
  disabled = false,
  children,
  className,
}: SelectableBoxProps) {
  return (
    <button
      type="button"
      onClick={() => !disabled && onSelect(id)}
      disabled={disabled}
      className={cn(
        'relative flex items-center justify-between rounded-md border-2 px-1 py-1.5 text-xs transition-all',
        selected
          ? 'border-[#2C2C2C] bg-[#2C2C2C] text-white hover:bg-[#2C2C2C]/90'
          : 'border-muted-foreground/20 bg-[#F5F5F5] text-gray-500 hover:border-muted-foreground/40 hover:bg-[#F5F5F5]/80',
        disabled && 'cursor-not-allowed opacity-50',
        className,
      )}
    >
      <div className="flex h-3 w-3 items-center justify-center">
        <AnimatePresence>
          {selected && (
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0, opacity: 0 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
              className="flex items-center justify-center"
            >
              <Check className="h-2.5 w-2.5 text-white" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <div className="text-left flex-shrink-0 px-1">{children}</div>
      <div className="h-3 w-3"></div>
    </button>
  )
}

interface SelectableBoxGroupProps {
  children: React.ReactNode
  className?: string
}

export function SelectableBoxGroup({
  children,
  className,
}: SelectableBoxGroupProps) {
  return <div className={cn('grid gap-3', className)}>{children}</div>
}
